import React from "react";
import PropTypes from "prop-types";
import ModelTemplateFormView from "./ModelTemplateFormView";
import ModelTemplateDetailsList from "./ModelTemplateDetailsList";

import { DataActions } from "../services/AxoServices";

import { withRouter, LoadingIndicator } from "../utilities/LexUtilities";

class ModelTemplateDetailsView extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      editing: false,
    };
  }

  static propTypes = {
    models: PropTypes.array.isRequired,
  };

  onSubmit = async (model) => {
    let response = await DataActions.updateModelTemplate(model);

    if (!response.ok) {
      return false;
    }

    this.setState({ editing: false });
  };

  onCancel = () => {
    this.setState({ editing: false });
  };

  render() {
    let { match, models, documentMap } = this.props;

    let { editing } = this.state;

    let id = parseInt(match.params.id, 10);
    let model = models.find((a) => a.id === id);

    if (!model) {
      return <LoadingIndicator />;
    }

    if (!editing) {
      return (
        <ModelTemplateDetailsList
          model={model}
          onEdit={() => this.setState({ editing: true })}
        />
      );
    }

    return (
      <ModelTemplateFormView
        key={model.id}
        startValue={model}
        documentMap={documentMap}
        onSubmit={this.onSubmit}
        onCancel={this.onCancel}
      />
    );
  }
}

export default withRouter(ModelTemplateDetailsView);
